import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { EditCustomFieldsButton } from "~/_components/EditCustomFieldsButton";
import { usePublicCustomFieldsPanel } from "~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel";
export const PublicBoardEditCustomFieldsButton = /*#__PURE__*/ memo(()=>{
    const { togglePanel } = usePublicCustomFieldsPanel();
    if (!togglePanel) return null;
    return /*#__PURE__*/ _jsx(EditCustomFieldsButton, {
        onClick: togglePanel
    });
});
PublicBoardEditCustomFieldsButton.displayName = "PublicBoardEditCustomFieldsButton";
